// PostHog Analytics (Client-side)
// For server-side analytics, import directly from '@/lib/analytics/server'

export type {
  AnalyticsEventMap,
  AnalyticsEventName,
  RenderingAnalyticsOperationType,
  RenderingAnalyticsSurface,
  RenderingAspectRatio,
  RenderingBaseImageSource,
} from './events';
export { capture, getSafeRenderingAspectRatio } from './events';
export { sanitizePII } from './sanitize';
